import React, { useState } from 'react';
import { Form, Row, Container, Col, Button } from 'react-bootstrap';
import Snackbar from '@mui/material/Snackbar';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

import qs from 'qs';

import './Login.css';
import { Token } from './Token';

export const Login = () => {
  const [username, setUsername] = useState();
  const [password, setPassword] = useState();
  const [loading, setLoading] = useState();
  const [isDisabled, setIsDisabled] = useState(false);
  const [open, setOpen] = useState(false);

  const { token, setToken } = Token();

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading('Loading...');
    handleDisable();

    const url = 'https://circleui-api.herokuapp.com/api/v1/login'
    const data = {
      'username': username,
      'password': password,
      'scope': 'me users logout'
    }
    const options = {
      method: 'POST',
      headers: {
        'accept': 'application/json',
        'content-type': 'application/x-www-form-urlencoded'
      },
      body: qs.stringify(data),
    };
    await fetch(url, options)
      .then(response => response.json())
      .then(data => {
        if (data.access_token) {
          setToken(data.access_token);
          window.location.reload();
        } else {
          setLoading('Incorrect Username or Password');
          handleUndisabled();
          console.log(data.detail);
        }
      })
      .catch(e => console.error('Error: ', e));
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  const handleDisable = () => {
    setOpen(true);
    setTimeout(() => setIsDisabled(true), 300);
  }

  const handleUndisabled = () => {
    setOpen(true);
    setTimeout(() => setIsDisabled(false), 2000);
  }

  return (
    <div className='auth-container'>
      <Container>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          message={loading}
          action={action}
        />
        <Row>
          <Col>
            <div className="login">
              <span id="login-text-circle">circle.</span><span id="login-text-ui">ui</span>
              <Form onSubmit={handleSubmit} className="form-login">
                <Form.Group>
                  <Form.Control type="text"
                                data-testid='username'
                                name='username'
                                placeholder='username'
                                autoComplete='off'
                                onChange={e => setUsername(e.target.value)}
                                required>
                  </Form.Control>
                  <Form.Control type="password"
                                data-testid="password"
                                name="password"
                                placeholder='password'
                                onChange={e => setPassword(e.target.value)}
                                required>

                  </Form.Control>
                </Form.Group>
                <Button disabled={isDisabled}
                        variant="warning"
                        type="submit"
                        data-testid='login__button'
                        className="login-button">
                  Login
                </Button>
              </Form>
              <p>Don't have an account? <a href='/register'>Sign up</a></p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}
